module.exports = __webpack_public_path__ + "media/01-Busqueda-articulos.281b7788.mp4";